module.exports = __webpack_public_path__ + "static/media/dodgem(29).38c4ecb7.PNG";